var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-name",
            label: _vm.$t("label.name"),
            "label-for": "input-name",
          },
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-name", type: "text", required: "" },
            model: {
              value: _vm.form.serv_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "serv_name", $$v)
              },
              expression: "form.serv_name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-perimeters",
            label: _vm.$t("label.perimeter"),
            "label-for": "input-perimeters",
          },
        },
        [
          _c("b-form-select", {
            attrs: {
              id: "input-perimeters",
              options: _vm.perimeters,
              required: "",
            },
            model: {
              value: _vm.form.serv_peri_id,
              callback: function ($$v) {
                _vm.$set(_vm.form, "serv_peri_id", $$v)
              },
              expression: "form.serv_peri_id",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "input-is_default",
            value: true,
            "unchecked-value": false,
            disabled: !_vm.allowDefault && !_vm.service.serv_is_default,
            required: "",
          },
          model: {
            value: _vm.form.serv_is_default,
            callback: function ($$v) {
              _vm.$set(_vm.form, "serv_is_default", $$v)
            },
            expression: "form.serv_is_default",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("label.default")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: {
            id: "input-is_enable",
            value: true,
            "unchecked-value": false,
            required: "",
          },
          model: {
            value: _vm.form.serv_is_enable,
            callback: function ($$v) {
              _vm.$set(_vm.form, "serv_is_enable", $$v)
            },
            expression: "form.serv_is_enable",
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("label.active")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                { attrs: { type: "submit", variant: "primary" } },
                [_vm._v(_vm._s(_vm.$t("btn.validate")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }